var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}.b,.c,.d,.f{fill:none;}.b,.c,.d{stroke:#c8d1ec;stroke-width:1.5px;}.c,.d{stroke-linecap:round;}.c{stroke-linejoin:round;}.e{stroke:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74,
    height: 74,
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.447 25.836)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(20.663 8.149)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 6.685,
    cy: 6.685,
    rx: 6.685,
    ry: 6.685
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 6.685,
    cy: 6.685,
    rx: 5.935,
    ry: 5.935
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 8.149)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 6.685,
    cy: 6.685,
    rx: 6.685,
    ry: 6.685
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 6.685,
    cy: 6.685,
    rx: 5.935,
    ry: 5.935
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6008.573,10173.962l4.623-8.417h9.5l-3.748,7.137s-.4,1.459-2.859,1.406S6008.573,10173.962,6008.573,10173.962Z",
    transform: "translate(-6001.011 -10159.505)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6014.885,10163.1h-3.332l5.041,9.514",
    transform: "translate(-6001.375 -10161.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6019.977,10160.3h3.25a1.875,1.875,0,0,1,2.1,1.611",
    transform: "translate(-5999.294 -10160.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6020.847,10160.513v5.74l6.021,8.605",
    transform: "translate(-5999.164 -10160.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M5748.74,10034.7h-2.678",
    transform: "translate(-5737.936 -10033.084)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.d9d367788a96d4e4ab886d1dcb984601.svg";
export { ForwardRef as ReactComponent };